import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { I18nLanguageEnum } from './enums';

declare const BUILD_TIMESTAMP: string;

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: I18nLanguageEnum['ភាសាខ្មែរ'],
    debug: IS_DEV,
    interpolation: {
      escapeValue: false,
    },
    ns: [],
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      queryStringParams: {
        v: BUILD_TIMESTAMP,
      },
      crossDomain: true,
      withCredentials: false,
    },
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      useSuspense: true,
    },
  });

export { i18n };
